import { Route } from "react-router-dom";

import Mission from "./components/mission/MissionControl";
// import Dashboard from "./components/_not_used_/dashboard/Dashboard";
import ResetPasswordPage from "./components/auth/ResetPassword";
import { PolicyList } from "./components/policy/PolicyList";
import { PolicyShow } from "./components/policy/PolicyShow";
import { ClaimsList } from "./components/claim/ClaimsList";
import { ClaimDbShow } from "./components/claim/ClaimDbShow";
import { AgriculturePoliciesList } from "./components/agriculturePolicies/AgriculturePoliciesList";
import { AgriculturePolicyShow } from "./components/agriculturePolicies/AgriculturePolicyShow";
import { AgricultureClaimsList } from "./components/agricultureClaims/AgricultureClaimsList";
import { AgricultureClaimShow } from "./components/agricultureClaims/AgricultureClaimShow";
import { ClimateDBList } from "./components/analytics/ClimateDBList";
import { RiskAssessment } from "./components/riskAssessment/RiskAssessment";
import { ClimateIndexMap } from "./components/climateIndex/ClimateIndexMap";
import { NatcatAnalyticsPage } from "./components/natcatAnalytics/NatcatAnalyticsPage";
import { AgroAnalyticsPage } from "./components/agroAnalytics/AgroAnalyticsPage";
import { KpiDashboard } from "./components/kpiDashboard/KpiDashboard";
import { EmergencyMonitoring } from "./components/emergencyMonitoring/EmergencyMonitoring";
import { EmergencyEventDetails } from "./components/emergencyMonitoring/eventDetails/EmergencyEventDetails";
import { Settings } from "./components/settings/Settings";
import { MiningAssets } from "./components/miningAssets/MiningAssets";
import { MineAssetDetails } from "./components/miningAssets/mineDetails/MineAssetDetails";
import { EventScope } from "./components/eventScope/EventScope";
import Documentation from "./components/documentation/Documentation";
// import Nowcast from "./components/nowcast/Nowcast";

/* eslint import/no-anonymous-default-export: [2, {"allowArray": true}] */
export default [
  <Route exact path="/settings" component={Settings} />,
  // <Route exact path="/nowcast" component={Nowcast} />,
  // <Route exact path="/kpi" component={Dashboard} />,
  <Route exact path="/newpolicies/:id/:mlid/:locationStartDateString" component={PolicyShow} />,
  <Route exact path="/newpoliciesLookup/:id2/:company" component={PolicyList} />,
  <Route exact path="/newpolicies" component={PolicyList} />,
  <Route exact path="/newclaims/:id" component={ClaimDbShow} />,
  <Route exact path="/newclaims" component={ClaimsList} />,
  <Route exact path="/climateAnalytics" component={ClimateDBList} />,
  <Route exact path="/policiesagriculture/:id" component={AgriculturePolicyShow} />,
  <Route exact path="/policiesagriculture" component={AgriculturePoliciesList} />,
  <Route exact path="/claimsagriculture/:policyId/:complainId" component={AgricultureClaimShow} />,
  <Route exact path="/claimsagriculture" component={AgricultureClaimsList} />,
  <Route exact path="/riskassessment" component={RiskAssessment} />,
  <Route exact path="/climateIndex" component={ClimateIndexMap} />,
  <Route exact path="/natcatAnalytics" component={NatcatAnalyticsPage} />,
  <Route exact path="/agroAnalytics" component={AgroAnalyticsPage} />,
  <Route exact path="/kpidashboard" component={KpiDashboard} />,
  <Route exact path="/emergencyMonitoring" component={EmergencyMonitoring} />,
  <Route exact path="/emergencyMonitoring/:id" component={EmergencyEventDetails} />,
  <Route exact path="/mining" component={MiningAssets} />,
  <Route exact path="/mining/:id" component={MineAssetDetails} />,
  <Route exact path="/eventScope" component={EventScope} />,
  <Route exact path="/documentation" component={Documentation} />,

  <Route path="/resetPassword/:confirmationCode" component={ResetPasswordPage} noLayout />,
  <Route exact path="/" component={Mission} noLayout />,
];
